import { EventEmitter, Injectable } from '@angular/core';
import { LoggingService } from 'src/app/shared/services/Logging.service';

@Injectable({
  providedIn: 'root'
})
export class SaveDataService {
  private formData: any = {};

  constructor(private loggingService: LoggingService,) { }


  setFormData(key: string, value: any): void {
    this.loggingService.log('key, value', key, value)
    this.formData[key] = value;
  }

  getFormData(): any {
    return this.formData;
  }
}
